import React from "react";
import "./Login.css";
import { accessUrl } from "./spotify";
import SpotLogoLogin from "./img/Spotify_Logo_Login.png"
// import { NavBar } from "./responsive/navbar";

import FooterNoLogin from "./FooterAndLinks/FooterNoLogin";
function Login() {

  return (


    <div className="login">
         {/* <div>  <NavBar/></div> */}
      <h2>Welcome to SongCarousel.com</h2>
      <p>Get FREE real human plays and feedback on your Spotify songs.</p>
   
<h3>How it works</h3>
      {/* <iframe width="392" height="220" src="https://www.youtube.com/embed/xMTwlnm1VFg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}

<p>
  
1) Listen and rate 5 songs<br/>
2) Add your Spotify song so it gets FREE plays and ratings<br/>
3) Repeat as many times and with as many songs as you want<br/><br/>

  
  </p>  
  <div className="smallFont">
     <p>
Only you will see the ratings you receive.</p>
  </div>

      <img
        src={SpotLogoLogin}
        alt="Login to Spotify"
    
      />
      <a href={accessUrl}>LOGIN TO SPOTIFY (with Premium Account)</a>
    
    <div> <FooterNoLogin /></div>
    </div>
  );
}

export default Login;
